import { AnyAction } from 'redux';
import { call, takeLatest, put } from 'redux-saga/effects';
import SweetAlert from 'sweetalert2';
import bcrypt from "bcryptjs";

import { solicitudActions } from './actions';
import {
  createSolicitudTypes,
  uploadFilesTypes,
  verifySolicitudStateTypes,
  updateSolicitudTypes,
  renewalSolicitudTypes,
  sendWhatsappCodeTypes,
  readRosetaTypes,
  viewFormTypes
} from './constants'
import services from '../../services';


function* createSolicitud({ payload }) {
  try {
    const res = yield call([services.solicitud, 'createSolicitud'], payload.values);
    if (res.status === 201) {
      SweetAlert.fire({
        icon: 'error',
        title: `${res.data}`,
        showConfirmButton: false,
        timer: 5000
      })
    }
    if (res.status === 200) {
      yield put(solicitudActions.createSolicitudSuccess(res.data));
    }
  } catch (err) {
    console.error('function*createSolicitud -> err', err);
    yield put(solicitudActions.createSolicitudFailure(err.message));
    SweetAlert.fire({
      icon: 'error',
      title: `Solicitud no registrada, ha habido un error!`,
      showConfirmButton: false,
      timer: 5000
    })
  }
}

function* verifySolicitudState({ payload }) {
  try {
    const res = yield call(
      [services.solicitud, 'verifySolicitudState'],
      payload,
    );
    if (res.data.type == undefined) { // responde undefined cuando es CODIGO 
      if (res.status == 201) { // si es rechazado o el codigo invalido
        if (res.data.msg) {
          SweetAlert.fire({
            icon: 'error',
            title: `${res.data.msg}`,
            text: `Compruebe el código, debe ser del formato: "ED-VP202XXXXXXX"`,
            showConfirmButton: false,
          })
        } else{
          yield put(solicitudActions.verifySolicitudStateSuccess(res.data));
        SweetAlert.fire({
          icon: 'warning',
          title: `${res.data}`,
          text: `Nota: Puede volver a realizar la solicitud una vez se hayan subsanado las observaciones.`,
          showConfirmButton: false,
        })
        }
      } else {
        if (res.data.estado){ // si no fue verificado
          yield put(solicitudActions.verifySolicitudStateSuccess(res.data));
          SweetAlert.fire({
            icon: 'warning',
            title: `${res.data.estado}`,
            showConfirmButton: true,
            confirmButtonText: "Ver y Descargar COMPROBANTE",
            text: `${res.data.msg}`,
          }).then(async (result) => {
            if (result.isConfirmed) {
              const salt = await bcrypt.genSalt(10);
              const hasheado = await bcrypt.hash(payload, salt);
              window.open(`${process.env.REACT_APP_SERVER_URI}/api/uploads/vouchers/external/${encodeURIComponent(hasheado)}/${payload}`);
            }
          })
        } else {
          yield put(solicitudActions.verifySolicitudStateSuccess(res.data));
          SweetAlert.fire({
            icon: 'success',
            title: `${res.data}`,
            showConfirmButton: true,
            confirmButtonText: "Ver y Descargar Reporte"
          }).then(async (result) => {
            if (result.isConfirmed) {
              const salt = await bcrypt.genSalt(10);
              const hasheado = await bcrypt.hash(payload, salt);
              window.open(`${process.env.REACT_APP_SERVER_URI}/api/uploads/formularios/external/${encodeURIComponent(hasheado)}/${payload}`);
            }
          })
        }
      }
    } else {
      if (res.status == 201) {
        yield put(solicitudActions.verifySolicitudStateSuccess(res.data.msg));
        SweetAlert.fire({
          icon: 'warning',
          title: `${res.data.msg}`,
          text: `Vehículo SIN trámites en proceso.`,
          showConfirmButton: false,
        })
      } else {
        yield put(solicitudActions.verifySolicitudStateSuccess(res.data.msg));
        SweetAlert.fire({
          icon: 'success',
          title: `${res.data.msg}`,
          text: `Vehículo con trámites en proceso.`,
          showConfirmButton: false
        })
      }
    }
  } catch (err) {
    console.error('function*verifySolicitudState -> err', err);
    yield put(
      solicitudActions.verifySolicitudStateFailure(err.message),
    );
    SweetAlert.fire({
      icon: 'error',
      title: `Ha habido un error en la solicitud.`,
      showConfirmButton: false,
      timer: 5000
    })
  }
}

function* uploadFiles({ payload }) {
  try {
    const res = yield call([services.solicitud, 'uploadFiles'], payload);
    if (res.status == 200) { 
      yield put(solicitudActions.uploadFilesSuccess(res.success));
      SweetAlert.fire({
        icon: 'success',
        title: ` Atención, su código de solicitud es:<strong style="color:#3867d6;">${payload.solicitudCod}</strong>`,
        text: 'La Solicitud se ha registrado exitosamente!, guarde el código de la solicitud para conocer el estado del trámite.',
        showConfirmButton: true,
      })
    } else {
      yield put(solicitudActions.uploadFilesFailure(res.error));
      SweetAlert.fire({
        icon: 'error',
        title: `${res.error}`,
        text: `ERROR al cargar los archivos, Solicitud NO registrada.`,
        showConfirmButton: true,
      })
    }

  } catch (err) {
    console.error('function*uploadFiles -> err', err);
    yield put(solicitudActions.uploadFilesFailure(err.message));
  }
}

function* updateSolicitud({ payload }) {
  try {
    const res = yield call([services.solicitud, 'updateSolicitud'], payload);
    if (res.status === 200) {
      yield put(solicitudActions.updateSolicitudSuccess(res.data));
    }
    if (res.status === 201) {
      SweetAlert.fire({
        icon: 'error',
        title: `${res.data}`,
        showConfirmButton: false,
        timer: 5000
      })
    }
  } catch (err) {
    console.error('function updateSolicitud -> err', err);
    yield put(solicitudActions.updateSolicitudFailure(err.message));
    SweetAlert.fire({
      icon: 'error',
      title: `Ha habido un error en la solicitud.`,
      showConfirmButton: false,
      timer: 5000
    })
  }
}

function* renewalSolicitud({ payload }) {
  try {
    const res = yield call([services.solicitud, 'renewalSolicitud'], payload.values);
    if (res.status === 201) {
      SweetAlert.fire({
        icon: 'error',
        title: `${res.data}`,
        showConfirmButton: false,
        timer: 5000
      })
    }
    if (res.status === 200) {
      yield put(solicitudActions.renewalSolicitudSuccess(res.data));
    }
  } catch (err) {
    console.error('function*renewalSolicitud -> err', err);
    yield put(solicitudActions.renewalSolicitudFailure(err.message));
    SweetAlert.fire({
      icon: 'error',
      title: `Ha habido un error!`,
      showConfirmButton: false,
      timer: 5000
    })
  }
}

function* sendWhatsappCode({ payload }) {
  try {
    const res = yield call(
      [services.solicitud, 'sendWhatsappCode'],
      payload,
    );
    if (res.status === 200 ){    
      yield put(solicitudActions.sendWhatsappCodeSuccess(res.data));
    } else {
      solicitudActions.sendWhatsappCodeFailure()
      SweetAlert.fire({
        icon: 'error',
        title: `Por favor intente nuevamente!`,
        showConfirmButton: true,
        timer: 5000
      })
    }
  } catch (err) {
    console.error('function*sendWhatsappCode -> err', err);
    yield put(
      solicitudActions.sendWhatsappCodeFailure(err.message),
    );
    SweetAlert.fire({
      icon: 'error',
      title: `Ha habido un error, por favor intente nuevamente!`,
      showConfirmButton: true,
      timer: 5000
    })
  }
}

function* readRoseta({ payload }) {
  try {
    const res = yield call(
      [services.solicitud, 'readRoseta'],
      payload,
    );
    yield put(solicitudActions.readRosetaSuccess(res.data));
  } catch (err) {
    console.error('function*readRoseta -> err', err);
    yield put(
      solicitudActions.readRosetaFailure(err.message),
    );
    SweetAlert.fire({
      icon: 'error',
      title: `Ha habido un error!`,
      showConfirmButton: false,
      timer: 5000
    })
  }
}

function* viewForm({ payload }) {
  try {
    const res = yield call(
      [services.solicitud, 'viewForm'],
      payload,
    );
    yield put(solicitudActions.viewFormSuccess(res.data));
  } catch (err) {
    console.error('function*viewForm -> err', err);
    yield put(
      solicitudActions.viewFormFailure(err.message),
    );
  }
}

function* solicitudSaga() {
  yield takeLatest(createSolicitudTypes.REQUEST, createSolicitud);
  yield takeLatest(verifySolicitudStateTypes.REQUEST, verifySolicitudState);
  yield takeLatest(uploadFilesTypes.REQUEST, uploadFiles);
  yield takeLatest(updateSolicitudTypes.REQUEST, updateSolicitud);
  yield takeLatest(renewalSolicitudTypes.REQUEST, renewalSolicitud);
  yield takeLatest(sendWhatsappCodeTypes.REQUEST, sendWhatsappCode);
  yield takeLatest(readRosetaTypes.REQUEST, readRoseta);
  yield takeLatest(viewFormTypes.REQUEST, viewForm);
}

export default solicitudSaga;